import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div className="min-h-screen w-full grid lg:grid-cols-5 bg-background text-foreground">
      {/* Left column - branding + hero */}
      <div
        className="relative hidden lg:flex lg:col-span-3 border-r border-zinc-800 overflow-hidden"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(9,9,11,0.55) 0%, rgba(9,9,11,0.9) 100%), url('https://images.pexels.com/photos/36823725/pexels-photo-36823725.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(circle at 30% 30%, rgba(255,178,36,0.12), transparent 55%)" }} />
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 bg-amber-400 grid place-items-center font-display font-black text-black">D</div>
            <div className="font-display font-black tracking-tight text-xl">DIGITEX / OPS</div>
          </div>
          <div>
            <div className="label-caps mb-4">Multi-Vertical Command Center</div>
            <h1 className="font-display font-black text-5xl xl:text-6xl leading-[0.95] tracking-tighter max-w-xl">
              Every unit. Every shift.
              <br />
              <span className="text-amber-400">One console.</span>
            </h1>
            <p className="mt-6 text-zinc-400 max-w-md text-sm leading-relaxed">
              Frozen · Roller Flour · Dehydration · Besan — production, inventory,
              electricity and sauda live-tracked with role-based access.
            </p>
          </div>
          <div className="flex gap-8 text-xs font-mono text-zinc-500">
            <div>
              <div className="text-amber-400 font-display text-2xl">04</div>
              <div className="label-caps text-[10px]">Units</div>
            </div>
            <div>
              <div className="text-amber-400 font-display text-2xl">24/7</div>
              <div className="label-caps text-[10px]">Ops window</div>
            </div>
            <div>
              <div className="text-amber-400 font-display text-2xl">RBAC</div>
              <div className="label-caps text-[10px]">Access</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right column - login */}
      <div className="lg:col-span-2 flex flex-col justify-center px-8 lg:px-14 py-16">
        <div className="max-w-sm w-full">
          <div className="label-caps mb-3">Govindgreen sign-in</div>
          <h2 className="font-display font-black text-3xl tracking-tight mb-2">
            Access the plant floor.
          </h2>

          <Button
            data-testid="google-login-btn"
            onClick={handleGoogleLogin}
            className="w-full h-12 mt-6 bg-amber-400 hover:bg-amber-300 text-black font-semibold rounded-none border border-amber-300 tracking-wide transition-colors"
          >
            <svg width="18" height="18" viewBox="0 0 48 48" className="mr-3">
              <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
              <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
              <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 34.869 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
              <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.089 5.571l6.19 5.238C39.99 34.522 44 30 44 24c0-1.341-.138-2.65-.389-3.917z"/>
            </svg>
            Continue with Google
          </Button>
        </div>
      </div>
    </div>
  );
}
